export const NOTE_CONTENT_SX = {
  mt: 1,
  fontSize: '0.875rem',
  lineHeight: 1.4,
  wordBreak: 'break-word',
  '& p': {
    my: 0,
  },
  '& p + p, & ul + p, & ol + p, & p + ul, & p + ol, & ul + ul, & ol + ol': {
    mt: 1,
  },
  '& ul, & ol': {
    margin: '8px 0 0',
    paddingLeft: '20px',
  },
  '& li': {
    marginBottom: '2px',
  },
  '& img': {
    display: 'block',
    maxWidth: '100%',
    maxHeight: 200,
    mt: 1,
    borderRadius: 1,
  },
  '& a': {
    color: 'primary.main',
  },
} as const;
